module.exports = __webpack_public_path__ + "img/entrance_inventory_fr.0deaf87f.svg";